// Third party imports
import { createSlice } from "@reduxjs/toolkit";

const sortByOrder = (items) =>
  [...items].sort((a, b) => parseFloat(a.order || 0) - parseFloat(b.order || 0));

/**
 * Configurable boards ("Bacheche team"): the list shown in the sidebar,
 * each board carrying its ordered columns.
 */
export const boardsSlice = createSlice({
  name: "boards",
  initialState: {
    boards: [],
    loaded: false,
  },
  reducers: {
    setBoards: (state, action) => {
      state.boards = action.payload || [];
      state.loaded = true;
    },
    upsertBoard: (state, action) => {
      const board = action.payload;
      const index = state.boards.findIndex((b) => b.id === board.id);
      if (index === -1) {
        state.boards.push(board);
      } else {
        state.boards[index] = { ...state.boards[index], ...board };
      }
      state.boards = sortByOrder(state.boards);
    },
    removeBoard: (state, action) => {
      state.boards = state.boards.filter((b) => b.id !== action.payload);
    },
    upsertColumn: (state, action) => {
      const column = action.payload;
      const board = state.boards.find((b) => b.id === column.board);
      if (!board) return;
      const columns = board.columns || [];
      const index = columns.findIndex((c) => c.id === column.id);
      if (index === -1) columns.push(column);
      else columns[index] = { ...columns[index], ...column };
      // Entry / done flags are unique per board: mirror the backend.
      board.columns = sortByOrder(
        columns.map((c) =>
          c.id === column.id
            ? c
            : {
                ...c,
                is_entry: column.is_entry ? false : c.is_entry,
                is_done: column.is_done ? false : c.is_done,
              }
        )
      );
    },
    removeColumn: (state, action) => {
      const { boardId, columnId } = action.payload;
      const board = state.boards.find((b) => b.id === boardId);
      if (board) {
        board.columns = (board.columns || []).filter((c) => c.id !== columnId);
      }
    },
  },
});

export const { setBoards, upsertBoard, removeBoard, upsertColumn, removeColumn } =
  boardsSlice.actions;
export default boardsSlice.reducer;
